import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { CheckCircle, ErrorOutline } from '@mui/icons-material';

export default function InviteAccept() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      localStorage.setItem('pendingInviteCode', code);
      navigate('/login');
      return;
    }

    (async () => {
      try {
        const res = await fetch('/api/challenges/invite/accept', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ code }),
        });
        const data = await res.json().catch(() => ({}));
        if (res.ok) {
          setStatus('success');
          setMessage(`Du bist jetzt mit ${data.friendEmail || 'deinem Freund'} verbunden!`);
        } else {
          setStatus('error');
          setMessage(data.error || 'Einladung konnte nicht angenommen werden.');
        }
      } catch {
        setStatus('error');
        setMessage('Verbindungsfehler.');
      }
    })();
  }, [code, navigate]);

  return (
    <Box sx={{
      minHeight: '100dvh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', px: 3, textAlign: 'center', gap: 2,
    }}>
      {status === 'loading' && <CircularProgress />}
      {status === 'success' && <CheckCircle color="success" sx={{ fontSize: 56 }} />}
      {status === 'error' && <ErrorOutline color="error" sx={{ fontSize: 56 }} />}

      <Typography variant="h6" fontWeight="bold">
        {status === 'loading' ? 'Einladung wird geprüft…' : status === 'success' ? 'Freundschaft bestätigt!' : 'Hoppla'}
      </Typography>
      {message && <Typography color="text.secondary">{message}</Typography>}

      {status !== 'loading' && (
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate('/challenges')}>
          Zu den Challenges
        </Button>
      )}
    </Box>
  );
}
